import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'
import { dateFormatter } from '../../../helpers/dateFormatter';
import PostTemplate from './templates/PostTemplate';

function ExternalPosts() {

    const [posts, setPosts] = useState([])

    useEffect(() => {
        
        try {
            const postsRef = firestore.collection("football-blogs-links");
            postsRef.onSnapshot(({docs}) => {
                const posts = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setPosts(posts)
            })
        } catch (error) {
            console.log(error)
        }

    }, [])

    return (
        <div className="row">
            {posts?.map((post, index) => {

                const date = new Date(post.date);
                const dateFormatted = dateFormatter(date);

                return (
                    <PostTemplate
                        key={index} 
                        title={post.title} 
                        author={post.source}
                        image={post.image}
                        type="external"
                        url={post.url}
                        date={dateFormatted}
                    />
                )
            })}
        </div>
    )

}
export default ExternalPosts